import { styled } from '@mui/material/styles';
import { TextInput } from 'shared/react-admin/Inputs/TextInputs';

export const StyledTextInput = styled(TextInput)({
  minWidth: 0,
});
